
class AbProductSummary extends HTMLElement {
  connectedCallback() {
    this.mainPrice = parseInt(document.querySelector('ab-product-addons')?.dataset.mainPrice || 0);
    this.mainQty = 1;
    document.addEventListener('addon:updated', this.updateDisplay.bind(this));
    document.addEventListener('variant:changed', ({ detail: { variant } }) => {
      this.mainPrice = parseInt(variant.price);
      this.updateAddToCartButton(variant.available);
      this.updateDisplay();
    });
    document.addEventListener('quantityChanged', ({ detail: { quantity } }) => {
      if (quantity) this.mainQty = quantity;
      this.updateDisplay();
    });
    this.updateDisplay();
  }
  
  updateDisplay() {
    const mainCount = this.querySelector('.main-product-count');
    const addonsCount = this.querySelector('.addons-count');
    const priceEl = this.querySelector('.ab-product-summary-price');
    
    let total = this.mainPrice * this.mainQty;
    let addonCount = 0;
    
    AddonState.addons.forEach((qty, variantId) => {
      const priceData = document.querySelector(`[data-variant-id="${variantId}"][data-price]`);
      if (priceData) {
        total += parseInt(priceData.dataset.price) * qty;
        addonCount += qty;
      }
    });
    
    if (mainCount) mainCount.textContent = `${this.mainQty} Item${this.mainQty > 1 ? 's' : ''}`;
    if (addonsCount) addonsCount.textContent = addonCount > 0 ? `${addonCount} add-on${addonCount > 1 ? 's' : ''}` : '0 add-on';
    if (priceEl) {
      const moneyFormat = document.querySelector('ab-product-addons')?.dataset.moneyFormat || '${{amount}}';
      const amount = (total / 100).toFixed(2); 
      const amountNoDecimals = Math.floor(total / 100).toString();
      priceEl.textContent = moneyFormat
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', amountNoDecimals);
    }
  }
  updateAddToCartButton(isAvailable) {
    document.querySelectorAll('.ab-global-atc__btn').forEach(button => {
      button.textContent = isAvailable ? 'Checkout' : 'Out of stock';
      button.disabled = !isAvailable;
    });
  }
}

customElements.define('ab-product-summary', AbProductSummary);
